module.exports = __webpack_public_path__ + "media/images/lb/024-cf574055654da448bcaabd74c973178e.svg";